import React, { PropTypes } from "react";
import { NitroButtonGroup, NitroButton } from "nitro-components";

const ButtonGroup = ({ filter, action }) => {
  
  const handleOptionSelect = option => {
    if (!filter.mandatory && option.value === filter.value) {
      action({ value: "", label: "" });
    } else {
      action(option);
    }
  };

  const { value, options } = filter;

  return (
    <NitroButtonGroup layout="vertical">
      {options &&
        options.map((option, index) => (
          <NitroButton
           disabled={option.disabled}
            key={index}
            label={option.label}
            action={() => handleOptionSelect(option)}
            block
            size="small"
            insideIconSize={16}
            leftIcon={value === option.value ? "success" : null}
            variant={value === option.value ? "secondary" : ""}
          />
        ))}
    </NitroButtonGroup>
  );
};

ButtonGroup.propTypes = {
  action: PropTypes.func,
  filter: PropTypes.object.isRequired
};

export default ButtonGroup;



// WEBPACK FOOTER //
// ./src/components/filter/filters/single-select/ButtonGroup.js